// fleet-generated: do not edit by hand
//
// Copied verbatim  : infra/fleet/artifacts/gestures/haptics.ts
// Parameters       : none — below this header, identical across the fleet
// Destination      : apps/web/src/lib/gestures/haptics.ts
//
// TO CHANGE THIS FILE, edit the canonical copy in infra and re-render. It
// changes for the whole fleet at once. Editing it here is reverted by the
// next render, and the guard in this repo goes red in the meantime:
//
//     cd ../infra && node fleet/fleet.ts render --repo meal-planner-app
//     node fleet/fleet.ts check --repo meal-planner-app
//
// The generator runs LOCALLY and is never invoked by CI. CI only verifies
// that what is committed matches the hash in .github/fleet-lock.json, which
// also records WHICH infra commit produced it. The commit is deliberately
// not repeated here: one value, one place — and stamping it into every file
// meant a one-line template edit rewrote four files in 28 repos.
/**
 * Haptic feedback — a thin, guarded wrapper over the Vibration API.
 *
 * Centralised so every gesture pulses consistently and so a future platform
 * adapter (Tauri native haptics) can be swapped in without touching
 * call sites.
 */

export function vibrate(ms: number): void {
  const nav = globalThis.navigator as Partial<Navigator> | undefined;
  if (nav?.vibrate) {
    nav.vibrate(ms);
  }
}
